import React, { useState, useEffect } from 'react';
import Lottie from 'react-lottie';
import './styles.scss';

const EnRPi = () => {
  const [animationData, setAnimationData] = useState(null);

  useEffect(() => {
    fetch("/2025/lottie/bulp.json")
      .then((response) => response.json())
      .then((data) => setAnimationData(data))
      .catch((error) => console.error("Error loading animation:", error));
  }, []);

  const lottieOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <section className="enrpi-section">
      <div className="enrpi-background">
        <img src="/2025/enpri/images/orangeLines.svg" alt="" />
      </div>

      <div className="enrpi-content">
        <div className="enrpi-left">
          <div className="enrpi-header">
            <img 
              src="/2025/enpri/icons/enpri-logo.svg" 
              alt="EnRPi" 
              className="enrpi-logo"
            />
            <p className="enrpi-subtitle">
              Енергийният сектор в един софтуер
            </p>
          </div>

          <div className="enrpi-text">
            <p>
              Централизирана среда за управление на клиенти, търговски операции, прогнози, борсови показатели, измервания от датчици и още много - всички утвърдени участници в енергетиката на България ни се доверяват и подпомагат превръщането на платформата в най-доброто решение в своята категория.
            </p>
          </div>
        </div>

        <div className="enrpi-right">
          <div className="enrpi-illustration">
            {animationData && <Lottie options={lottieOptions} />}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EnRPi;
